import api from './api';

const MunicipalityUserService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/municipality-users/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/municipality-users/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/municipality-users/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/municipality-users/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  partialUpdate: async (id, data) => {
    try {
      const response = await api.patch(`/municipality-users/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/municipality-users/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default MunicipalityUserService;
